import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import "./Accordion.css";

function Accordion(props) {

	const [ isActive, setIsActive ] = useState(false);
	const [ maxHeight, setMaxHeight ] = useState(0);
	const [ hasBeenToggled, setHasBeenToggled ] = useState(false);
	const content = useRef(null);
	const headContentRef = useRef(null);

	let accordionClass = props.isTopAccordion ?  "accordion_section top_accordion" : "accordion_section";
	let accordionContentClass = props.contentClass ? "accordion_content " + props.contentClass : "accordion_content";
	let iconRightDivClass = props.iconRight ? "accordion_icon_right" : "";
	let iconLeftDivClass = "accordion_icon_left";

	const {
		iconLeftAnimate,
		iconRightAnimate,
		parentActive,
		expandParent,
		controlled,
		isOpen,
		disabled,
		onClick,
		shouldClose,
		isOpenClass
	} = props;

	const active = controlled ? isOpen : isActive;

	if ( active ){
		accordionClass = isOpenClass ? accordionClass + " " + isOpenClass : accordionClass + " is_open";
		if ( iconRightAnimate === true ){
			iconRightDivClass = props.iconRight ? "accordion_icon_right rotate_down" : "";
		}
		if ( iconLeftAnimate === true ){
			iconLeftDivClass = "accordion_icon_left rotate_down";
		}
	} else if ( hasBeenToggled ){
		if ( iconRightAnimate === true ){
			iconRightDivClass = props.iconRight ? "accordion_icon_right rotate_up" : "";
		}
		if ( iconLeftAnimate === true ){
			iconLeftDivClass = "accordion_icon_left rotate_up";
		}
	}

	const _expandParent = (height, expand) =>{
		setMaxHeight( expand ? (maxHeight + height) : (content.current.scrollHeight - height) );
	}

	function toggleAccordion(e){
		if ( !disabled && e.target.tagName !== 'BUTTON' ){
			onClick?.(!active);
			if ( !controlled ){
				headContentRef.current.style.pointerEvents = 'none';
				setHasBeenToggled(true);
				setIsActive( !active );
				let height = active ? 0 : content.current.scrollHeight + 32; //in function scope, active hasn't changed values yet.
				setMaxHeight( height );

				if ( expandParent ){
					expandParent(height, !active);
				}	

				if ( height > 0 ){
					let delay = Number( content.current.style.transitionDuration.replace('s','') ) * 1200;
					setTimeout(() => {
						// if( content.current ){
							content.current.style.overflow = "visible";
							headContentRef.current.style.pointerEvents = 'auto';
						// }
					}, delay);
				} else {
					content.current.style.overflow = "hidden";
					headContentRef.current.style.pointerEvents = 'auto';
				}
			}
		}
	}

	function dynamicSize(){
		if ( active ){
			let height = content.current.scrollHeight + 32;
			setMaxHeight( height );
			if ( expandParent ){
				let shouldGrow = height > maxHeight ? true : false;
				let heightDifference = shouldGrow ? height - maxHeight : maxHeight - height;
				expandParent(heightDifference , shouldGrow);
			}
		}
	}

	const children = React.Children.map( props.children, child =>{
		if( child.props.contentDescription ){
			return React.cloneElement(child, { expandParent: _expandParent, parentActive: active });
		}
		return child;
	});


	useEffect(() => {
		if( controlled ){
			if( active ){
				headContentRef.current.style.pointerEvents = 'none';
				setHasBeenToggled(true);
				let height =  content.current.scrollHeight + 32;
				setMaxHeight( height );
				if ( expandParent ){
					expandParent(height, !active);
				}	
				let delay = Number( content.current.style.transitionDuration.replace('s','') ) * 1200;
				setTimeout(() => {
					content.current.style.overflow = "visible";
					headContentRef.current.style.pointerEvents = 'auto';
				}, delay);

			} else if( active === false && content.current !== null ) {
				headContentRef.current.style.pointerEvents = 'none';
				// setTimeout(() => {
					if( content.current !== null ){
						content.current.style.overflow = "hidden";
						// setIsActive( false );
						setMaxHeight(0);
						headContentRef.current.style.pointerEvents = 'auto';
					}
				// }, 1);
			}
		}
	}, [ active, content, headContentRef ]);

	useEffect(()=>{ //collapse children accordions if parent is collapsed.
		if ( parentActive === false ){
			content.current.style.overflow = "hidden";
			setIsActive( false );
			setMaxHeight(0);
		}
	}, [ parentActive ]);

	useEffect(()=>{ //allow for dynamic resizing transition of parent if child content dynamically grows
		dynamicSize();
	}, [ props.children ]);

	useEffect(()=>{ //set transition
		if ( content ){
			content.current.style.transition = "max-height 0.4s ease-out";
		}
	}, [ content ]);

	useEffect(() => {
		if( shouldClose === true ){
			headContentRef.current.style.pointerEvents = 'none';
			setIsActive( false );
			let height =  0;
			setMaxHeight( height );
			if ( expandParent ){
				expandParent(height, false);
			}
			content.current.style.overflow = "hidden";
			headContentRef.current.style.pointerEvents = 'auto';
		}
	}, [ shouldClose ]);

  	return (
	    <div className={ accordionClass }>
	      	<div
				className="accordion_header"
				onClick={ toggleAccordion }
				ref={ headContentRef }
			>
				<div className={iconLeftDivClass}>
					{ props.iconLeft }
				</div>
				<div className="accordion_head_content">
					{ props.headContent }
				</div>
				<div className={ iconRightDivClass }>
					{ props.iconRight }
				</div>
			</div>
			<div
				ref={ content }
				style={{ maxHeight: `${maxHeight}px` }}
				className={ accordionContentClass }
			>
	        	{children}
				<div className="open"></div>
	        </div>
	    </div>
  	);
}

Accordion.propTypes = {
	contentDescription: PropTypes.string,
	headContent: PropTypes.object,
	isTopAccordion: PropTypes.bool,
	iconLeft: PropTypes.object,
	iconRight: PropTypes.object,
	iconRightAnimate: PropTypes.bool,
	iconLeftAnimate: PropTypes.bool,
	disabled: PropTypes.bool,
	shouldClose: PropTypes.bool,
	isOpen: PropTypes.bool,
	controlled: PropTypes.bool,
	expandParent: PropTypes.func,
	parentActive: PropTypes.bool
};

export default Accordion;